import { MapDrawUpdatedEventData } from './map-draw-updated-event-data';
import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapDrawUpdatedEvent implements MapEvent {
    type = MapEventType.mapDrawUpdated;
    constructor(public payload: MapDrawUpdatedEventData) {}
}
